<template>
  <transition name="fade">
    <div class="popup" id="popup_forget_pass" v-on:click="$store.commit('forgetPassword', false)">
      <div class="popup_block" @click.stop>
        <div class="close" v-on:click="$store.commit('forgetPassword', false)"></div>
        <div class="pos_relative">
          <div class="text_popup">{{ $store.getters.t('find_your_account') }}</div>
          <form v-on:submit.prevent="forget()">
            <div class="input_type">
              <span v-on:click="activeInput($event)">{{ $store.getters.t('email') }}</span>
              <input
                v-validate="'required|email'"
                name="email"
                placeholder="example@email.com"
                required
                type="email"
                v-on:input="activeInput($event)"
                v-on:keyup.tab="activeInput($event)"
                v-on:click="activeInput($event)"
                v-model="email"
              >
              <div
                class="error_text"
                v-show="errors.first('email')"
              >{{$store.getters.t('email_error')}}</div>
              <div class="correct_text" v-show="!errors.first('email')"></div>
            </div>
            <input class="submit_button" type="submit" :value="$store.getters.t('recover')">
          </form>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import beautifulForm from "../../../mixins/beautifulForm.js";
export default {
  data() {
    return {
      email: ""
    };
  },
  mixins: [beautifulForm],
  methods: {
    forget() {
      if (this.email.trim().length && !this.errors.first("email")) {
        NProgress.start();
        this.$http({
          method: "post",
          url: `/api/forget-password`,
          data: { email: this.email }
        }).then(res => {
          if (res.data.success) {
            this.$store.commit("forgetPassword", false);
            this.$store.commit("newMessage", {
              show: true,
              type: "success",
              messageTitle: this.$store.getters.t("success"),
              message: this.$store.getters.t("teoken_sended")
            });
          } else {
            this.errors.add({
              scope: null,
              field: "email",
              msg: "invalid"
            });
          }
        });
        NProgress.done();
      }
    }
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/modals/forgetPassword/forget.vue